import React, { Component } from "react";
import ToggleDrawer from "../containers/ToggleDrawer";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";
import LabelWithTooltipMfa from "../label/LabelWithTooltipMfa";

export default class TextInputMfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false 
    };
  }

  render() {
       return (
      <div className={"text-input fieldContainerMfa"}  >
        <div className="topFieldContainer">
          <div className="form-group">  
             <LabelWithTooltipMfa  label= "Enter your membership number" tooltipContent= {this.props.iconToolTipMfa} />  
            {this.props.tooltipContent ? (
              <i
                className="icon-info-blue"
                onClick={() => {
                  this.setState({
                    toolTipVisible: !this.state.toolTipVisible
                  });
                }}
                tabIndex="0"
                title="Click for more information"
                role="button"
                onKeyPress={e => {
                  handleKeyPress(e, () => {
                    this.setState({
                      toolTipVisible: !this.state.toolTipVisible
                    });
                  });
                }}
              />
            ) : null}
            <input
              className={
                "  formfeildinputMFA" +
                (this.props.hasError ? " is-invalid-Mfa" : " is-valid")
              }
             
              name={this.props.inputId}
              disabled={this.props.disabled}
              value={this.props.inputValue}
              type="text"
              id={this.props.inputId}
              onChange={this.props.onChange}
              maxLength={this.props.maxLength}
              autoComplete={this.props.autoComplete}
              placeholder={this.props.placeholder}
             
            />
          </div>
        </div>

        <div className={this.props.tooltipStyle}>
          <ToggleDrawer
            isOpen={this.state.toolTipVisible}
            gradientClass={this.props.gradientClass}
            bottom
          >
            <div className={"input-tooltip"}>{this.props.tooltipContent}</div>
          </ToggleDrawer>
        </div>
      </div>
    );







    
  
 
  }
}
